import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'huntsville-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'Huntsville Hospital Urgent Care',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1-615-988-2000,
  email: 'support@hhurgentcare.org',
  poweredByLogo: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/huntsville/index.js